<template>
  <div>
    <div :id="stepperId" class="stepper">
      <b-tabs content-class="mt-3">
        <b-tab 
          v-for="(tab,index) in tabs"
          :key="tab.tabId"
          :name="tab.tabId"
          :button-id="tab.tabId" 
          :active="currentTabId === tab.tabId"  
          :disabled="currentTabId !== tab.tabId"
        >
          <template slot="title">
            <span class="step-number-badge">{{ tab.stepNumber }}</span>
            <span class="step-title">{{ tab.tabName }}</span>
          </template>
          <p>
            <b-card-text>
              <slot :name="'content-for-tab-' + (index + 1)" />
            </b-card-text>
          </p>
        </b-tab>
      </b-tabs>
      <hr>
      <div class="stepper-bottom row px-4 no-gutters bg-light pb-4 border-bottom col-lg-12 col-sm-12">
        <div class="col-lg-12 col-md-12 col-sm-12 pr-2">
          <DnFunctionButton
            button-id="nextOrSubmitBtn"
            :callback-fn="TryNextOrSubmit"
            :text="NextOrSubmitButtonText"
            extra-classes="pull-right"
            :size="largeSize"
          />
          <DnFunctionButton
            v-if="currentTabId !== 'orderLookupTab'"
            button-id="backBtn"
            extra-classes="pull-right mr-3"
            :callback-fn="GoToPreviousStep"
            text="Back"
            :size="largeSize"
          />
        </div>
      </div>                         
    </div>     
  </div>
</template>

<script>
  import $ from "jquery"
  import { mapGetters } from "vuex"
  import { stringHelper } from "@/components/mixins/stringHelper"
  import { sizeHelper } from "@/components/mixins/sizeHelper"
  import DnFunctionButton from "@/components/Elements/DnFunctionButton"
  import { constants } from "os";

  export default {
    components: {
      DnFunctionButton
    },
    mixins: [stringHelper, sizeHelper],
    props: {
      tabs: Array,
      initialActiveTabId: {
        type: String,
        default: ""
      },
      stepperId: String
    },
    data: () => ({
      NextOrSubmitButtonText: "Next",
      currentTabId: String
    }),
    computed: {
      ...mapGetters(["activeAccountId", "user"]),
    },
    mounted() {
      this.currentTabId = this.initialActiveTabId;
    },
    methods: {
      TryNextOrSubmit: function () {
        this.$emit("clickedNextOrSubmitButton");
      },
      GoToNextTab (){
        let currentTabLink = $("#" + this.stepperId +" .nav-tabs .nav-link.active");
        currentTabLink.find(".step-number-badge").css("background-color", "#999");
        let currentTab = currentTabLink.closest(".nav-item");
        let nextTab = currentTab.next();
        nextTab.find(".step-number-badge").css("background-color", "#205cb7");
        let nextTabId = nextTab.find(".nav-link").attr("id");
        this.currentTabId = nextTabId;
      },
      GoToPreviousStep (){
        let currentTabLink = $("#" + this.stepperId +" .nav-tabs .nav-link.active");
        currentTabLink.find(".step-number-badge").css("background-color", "white");
        let currentTab = currentTabLink.closest(".nav-item");
        let prevTab = currentTab.prev();
        prevTab.find(".step-number-badge").css("background-color", "#205cb7");
        let prevTabId = prevTab.find(".nav-link").attr("id");
        this.currentTabId = prevTabId;
        this.$emit("clickedBackButton");
      }
    }
  }
  
</script>
<style lang="scss">
  .step-number-badge{
    background-color: #205cb7;
    color: white;
    width: 3.5rem;
    height: 3.5rem;
    display: flex;
    flex-shrink: 0;
    font-size: 1.5rem;
    border-radius: 50%;
    margin-right: 0.5rem;
    align-items: center;
    justify-content: center;
    border: 1px solid #f4f4f4;
    box-shadow: 0.25rem 0.25rem 0.5rem rgba(0, 0, 0, 0.25);
    box-sizing: inherit;
    font-weight: bold;
    pointer-events: none;
    user-select: none;
    float: left;
  }
  .step-title{
    color: black;
    box-sizing: inherit;
    display: block;
    float: right;
    transform: translateY(20px);
  }
  .stepper{
    .nav{
      margin-bottom: 0;
    }
    .nav-link{
      display: inline-block;
      border: none !important;
      font-size: 1rem;
      font-weight: bold;
      text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25);
      pointer-events: none;
      user-select: none;
      padding: 0.7rem;

      &.disabled{
        .step-number-badge{
            background-color: white;
            color: grey;
        }
        .step-title{
          color: grey;
        }
      }
    }
    hr{
      border-top: 4px solid black;
      margin: 0;
    }
    .stepper-bottom{
      padding-top: 12px;
    }
    .card-text{
      margin-bottom: 0;
      padding-bottom: 0;
       >*{
         padding-bottom: 24px;
         padding-top: 12px;
       }
    }
    .tab-pane.active{
      margin-bottom: 0;
      padding-bottom: 0;
      >p{
        margin-bottom: 0;
        padding-bottom: 0;
      }
    }
    .tab-content{
      //need to override bootstrap's !important style
      margin-top: 0 !important;
    }
  }
</style>